import { Tab, tabTemplate as template } from '@microsoft/fast-foundation';
import { TabComponent } from './Tab';
import styles from './Tab.styles.scss';
export const chameleonTab = TabComponent.compose({
    baseName: 'tab',
    baseClass: Tab,
    template: template,
    styles,
});
